import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";

import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";
import SetVisitDate from "./SetVisitDate";

const SiteVisitPage = () => {
  const pageInfo = useGetPageInfo();

  const [scheduledVisitTime, setScheduledVisitTimeState] = useState({
    open: false,
    id: null,
  });

  const dataList = useLoaderData("root");

  const onScheduledVisitTimeClicked = (row) => {
    setScheduledVisitTimeState({ id: row.id, open: true });
  };

  let navigate = useNavigate();
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    data: {},
    cascadeDelete: false,
  });
  const headCells = [
    {
      id: "updateOn",
      label: "تاریخ",
      type: "date",
    },

    {
      id: "requestTitle",
      label: "عنوان درخواست",
    },
    {
      id: "scheduledVisitTime",
      type: "persiandatetime",
      label: "زمان هماهنگ‌شده",
    },
    {
      id: "actualVisitTime",
      type: "persiandatetime",
      label: "زمان انجام بازدید",
    },

    {
      id: "billId",
      label: "شناسه قبض",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onFetchData = () => {
    navigate();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
        <SetVisitDate
          open={scheduledVisitTime.open}
          id={scheduledVisitTime.id}
          onClose={(loadAgain) => {
            setScheduledVisitTimeState({
              open: false,
              id: null,
            });
            if (loadAgain) {
              onFetchData();
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={dataList}
                  headCells={headCells}
                  pageSize={100}
                  actions={[
                    {
                      icon: (
                        <BlockIcon sx={{ width: "1rem", height: "1rem" }} />
                      ),
                      onClick: onScheduledVisitTimeClicked,
                      color: "secondary",
                    },
                    {
                      icon: useCheckPermission("edit") ? (
                        <EditIcon sx={{ width: "1rem", height: "1rem" }} />
                      ) : null,
                      onClick: onEditClicked,
                      color: "primary",
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SiteVisitPage;

